import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-175362d1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { useVModel } from '@vueuse/core';
import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { addNews } from '@/api/news';
import CropImageUpload from '@/components/CropImageUpload';
import EditorCom from '@/components/EditorCom';
export default {
  __name: 'NewsDialog',
  props: {
    title: {
      type: String,
      default: '新增广告组'
    },
    // 是否回显数据
    model: {
      type: Object,
      default: null
    },
    modelValue: {
      type: Boolean,
      required: true
    },
    code: {
      type: Number
    },
    groupId: {
      type: String,
      required: true
    },
    type: {
      type: Number,
      default: 1
    },
    tenantId: {
      type: [String, Number],
      required: true
    }
  },
  emits: ['update:modelValue', 'refreshData', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;

    // 表单数据
    const formData = ref({
      name: '',
      code: '',
      url: '',
      link: '',
      content: ''
    });
    watch(() => props.model, val => {
      if (val) {
        formData.value = JSON.parse(JSON.stringify(val));
      } else {
        formData.value = {
          name: '',
          code: '',
          url: '',
          link: '',
          content: ''
        };
      }
    }, {
      immediate: true
    });
    const emits = __emit;
    const isVisible = useVModel(props);
    const rules = ref({
      name: [{
        required: true,
        message: '标题不能为空',
        trigger: 'blur'
      }],
      note: [{
        required: true,
        message: '描述不能为空',
        trigger: 'blur'
      }]
    });

    // 表单元素
    const formEl = ref(null);

    /**
     * 新增事件
     */
    const addNewsHandler = async () => {
      if (!formEl.value) return;
      await formEl.value.validate(async (valid, fields) => {
        if (valid) {
          try {
            if (props.model) {
              await addNews(formData.value);
            } else {
              await addNews({
                groupId: props.groupId,
                ...formData.value,
                code: props.code
              });
            }
            emits('refreshData');
            resetForm();
            ElMessage({
              type: 'success',
              message: '添加成功'
            });
          } catch (error) {
            console.log(error);
          } finally {
            isVisible.value = false;
          }
        }
      });
    };
    const resetForm = () => {
      formEl.value.resetFields();
      formData.value = {
        name: '',
        code: '',
        url: '',
        link: '',
        content: ''
      };
      if (props.model) {
        emits('clearModel');
      }
    };
    const closed = () => {
      resetForm();
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        title: `${__props.model ? '修改' : '新增'}广告位`,
        width: "50%",
        onClosed: closed,
        class: "dialog-class",
        "destroy-on-close": "",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = $event => isVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: addNewsHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "150px",
          model: formData.value,
          rules: rules.value,
          style: {
            "max-width": "90%"
          },
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [__props.model ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "序号",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.code,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.code = $event),
              placeholder: "请输入广告组序号"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "标题",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.name = $event),
              placeholder: "请输入广告组标题"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), __props.type === 2 || __props.type === 3 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "链接",
            prop: "link"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.link,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.link = $event),
              placeholder: "请输入广告组跳转链接"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type === 2 || __props.type === 3 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: "图片"
          }, {
            default: _withCtx(() => [_createVNode(_unref(CropImageUpload), {
              modelValue: formData.value.url,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.url = $event),
              id: __props.tenantId,
              path: "news",
              width: 480,
              height: 270
            }, null, 8, ["modelValue", "id"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type === 1 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 3,
            label: "公告内容"
          }, {
            default: _withCtx(() => [_createVNode(_unref(EditorCom), {
              modelValue: formData.value.content,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.value.content = $event),
              width: "100%",
              height: "500"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};